<template>
  <div class="map-result" :class="{ 'full-screen': activeTab !== 0 }">
    <div class="result-tabs">
      <div class="result-tab tab-map" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10.92"
          height="14.843"
          viewBox="0 0 10.92 14.843"
        >
          <path
            d="M1202.1,468.128a5.343,5.343,0,0,0-8.637,0,4.743,4.743,0,0,0-.493,3.986,13.768,13.768,0,0,0,1.037,2.37,44.242,44.242,0,0,0,3.026,4.764c.131.185.266.367.4.553a.429.429,0,0,0,.69,0c.137-.185.272-.368.4-.553a44.164,44.164,0,0,0,3.026-4.764,13.742,13.742,0,0,0,1.037-2.37A4.744,4.744,0,0,0,1202.1,468.128Zm-4.314,5.768h-.01a3.07,3.07,0,1,1,.01,0Z"
            transform="translate(-1192.321 -465.531)"
            fill="none"
            stroke="#2C2C2C"
            stroke-width="0.8"
          ></path>
        </svg>
        <span>Map</span>
      </div>
      <div class="result-tab tab-list" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.582"
          height="10.264"
          viewBox="0 0 13.582 10.264"
        >
          <g transform="translate(-1548.797 -161.537)">
            <rect
              width="9.584"
              height="1.615"
              transform="translate(1552.795 161.537)"
              fill="#2c2c2c"
            ></rect>
            <rect
              width="9.584"
              height="1.615"
              transform="translate(1552.795 165.861)"
              fill="#2c2c2c"
            ></rect>
            <rect
              width="9.584"
              height="1.615"
              transform="translate(1552.795 170.185)"
              fill="#2c2c2c"
            ></rect>
            <rect
              width="2.08"
              height="1.615"
              transform="translate(1548.797 161.537)"
              fill="#2c2c2c"
            ></rect>
            <rect
              width="2.08"
              height="1.615"
              transform="translate(1548.797 165.861)"
              fill="#2c2c2c"
            ></rect>
            <rect
              width="2.08"
              height="1.615"
              transform="translate(1548.797 170.185)"
              fill="#2c2c2c"
            ></rect>
          </g>
        </svg>
        <span>List</span>
      </div>
      <div
        class="result-tab tab-snapshots"
        :class="{ active: activeTab === 2 }"
        @click="activeTab = 2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10.264"
          height="10.264"
          viewBox="0 0 10.264 10.264"
        >
          <g transform="translate(-1882.004 -161.537)">
            <path
              d="M1882,161.537V171.8h10.264V161.537Zm9.486,9.486h-8.708v-8.708h8.708Z"
              transform="translate(0 0)"
              fill="#2c2c2c"
            ></path>
            <path
              d="M1926.265,199.785h-6.013V205.8h6.013Zm-.778,5.235h-4.457v-4.457h4.457Z"
              transform="translate(-36.122 -36.123)"
              fill="#2c2c2c"
            ></path>
          </g>
        </svg>
        <span>Snapshots</span>
      </div>
    </div>
    <div class="experiences-list" v-show="activeTab < 2">
      <VuePerfectScrollbar class="scroll-area" v-if="experiences && experiences.length > 0">
        <div v-for="experience in experiences" :key="experience.id" class="experience">
          <div
            class="experience-thumbnail"
            :style="{ backgroundImage: `url(${experience.thumbnailUrl})` }"
            @click="() => openExperience(experience)"
          ></div>
          <div class="experience-detail">
            <h4 class="experience-title" @click="() => openExperience(experience)">{{experience.title}}</h4>
            <div class="experience-description" v-if="experience.description">
              {{experience.description | truncate(110)}}
              <span
                class="more"
                @click="() => openExperience(experience)"
              >More</span>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
      <div
        v-if="!experiences || experiences.length < 0"
        class="empty-result"
      >There are no result here.</div>
    </div>

    <div class="snapshots-list" v-show="activeTab === 2">
      <VuePerfectScrollbar v-if="snapshots && snapshots.length > 0" class="scroll-area">
        <div class="snapshots-list-inner">
          <div
            v-for="snapshot in snapshots"
            :key="snapshot.id"
            class="snapshot"
            :style="{ backgroundImage: `url(${snapshot.media})` }"
          ></div>
        </div>
      </VuePerfectScrollbar>
      <div v-if="!snapshots || snapshots.length < 1" class="empty-result">There are no result here.</div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ExperienceService from "../services/experience";
export default {
  name: "MapResult",
  components: {
    VuePerfectScrollbar
  },
  props: {
    experiences: {
      type: Array,
      default: () => []
    },
    snapshots: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: 0
    };
  },
  methods: {
    openExperience(exp) {
      ExperienceService.openPopup(exp.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.map-result {
  position: fixed;
  z-index: 1001;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: #fff;
  font-size: 13px;
  display: flex;
  flex-direction: column;

  &.full-screen {
    bottom: auto;
    top: 52px;
    .experiences-list,
    .snapshots-list {
      order: 0;
      height: calc(100vh - 83px);
      z-index: 1;
    }

    .result-tabs {
      order: 1;
      z-index: 2;
      position: fixed;
      bottom: 0;
    }
  }

  .result-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    border-top: 1px solid rgba(44, 44, 44, 0.35);

    .result-tab {
      text-align: center;
      flex: 1;
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: #2c2c2c;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        margin-right: 7px;
      }

      &.active {
        background-color: #e13036;
        color: #fff;
        path {
          stroke: #fff;
        }
      }
    }
  }

  .experiences-list {
    width: 100vw;
    height: 100px;

    .scroll-area {
      width: 100%;
      height: 100%;
    }

    .experience {
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: row;
      border-top: 1px solid rgba(44, 44, 44, 0.35);

      .experience-thumbnail {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 33%;
        height: 100%;
        flex: 0 0 auto;
      }

      .experience-detail {
        padding: 3.33vw;
      }

      .experience-title {
        font-size: 13px;
        font-weight: bold;
        margin: 0 0 0.5em;
      }

      .experience-description {
        font-size: 10px;

        .more {
          color: #9d9d9d;
          font-weight: bold;
          display: inline-block;
          margin-left: 5px;
        }
      }
    }
  }

  .snapshots-list {
    width: 100vw;
    height: 100px;

    .scroll-area {
      width: 100%;
      height: 100%;
    }

    .snapshots-list-inner {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-rows: 1fr;
      width: 100%;
    }
    .snapshot {
      width: 100%;
      height: 100%;
    }
  }

  .empty-result {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
